// @ts-nocheck
import React from 'react';
import {
  Box,
  IconButton,
  DialogContent,
  Dialog,
  DialogTitle,
  Typography,
  Grid,
} from '@mui/material';
import SolyticsTypography from '../../../../package/components/SolyticsTypography';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';

import useModalDisclosure from '../../../../hooks/useModalDisclosure';

const ViewTextFieldExtended = ({ value, attribute }) => {
  const { open: openPreview, handleOpen, handleClose } = useModalDisclosure();

  return (
    <Grid container item xs={12}>
      <Grid item xs={12}>
        <Box display="flex" alignItems="center">
          <SolyticsTypography ellipsis>{value}</SolyticsTypography>

          <Typography
            component="span"
            onClick={handleOpen}
            sx={{
              ml: 0.2,
              color: 'primary.main',
              cursor: 'pointer',
              textDecoration: 'underline',
              flexShrink: 0,
            }}
          >
            Read More
          </Typography>
        </Box>
      </Grid>

      <Dialog open={openPreview} onClose={handleClose} maxWidth="lg" fullWidth>
        <DialogTitle>
          <Typography
            aria-live="polite"
            aria-atomic="true"
            sx={{
              wordWrap: 'break-word',
            }}
          >
            {attribute?.label}
          </Typography>
        </DialogTitle>

        <IconButton
          color="primary"
          aria-label="Close dialog"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 16,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <DialogContent
            sx={{
              p: 0,
            }}
          >
            <Typography
              sx={{
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
              }}
            >
              {value || '-'}
            </Typography>
          </DialogContent>
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

ViewTextFieldExtended.propTypes = {
  value: PropTypes.string,
  attribute: PropTypes.shape({
    label: PropTypes.string,
  }).isRequired,
};

export default ViewTextFieldExtended;
